import { Component, Inject } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { MD_DIALOG_DATA, MdDialogRef } from "@angular/material";
import { LicenseService } from "../../../services/LicenseService";
import { AppLoaderService } from "../../../../services/app-loader/app-loader.service";
import { apply } from "core-js/fn/reflect";
import { ExportToCSVService } from "../../../services/ExportToCSVService";
import { AdalService } from "../../../shared/adal.service";
import { Router } from "@angular/router";

@Component({
    selector:'add-edit-faq',
    template:require('./add-edit-faq.component.html'),
    styles:[require('./add-edit-faq.component.css')]
})
export class AddEditFaqComponent{
    dialogTitle='Add FAQ';
    errorMessage='';
    FAQForm:FormGroup;
    FaqList;
    selectedFAQDetail;
    constructor(
        private formBuilder:FormBuilder,
        private dialogRef:MdDialogRef<AddEditFaqComponent>,
        private licenseService:LicenseService,
        private appLoader:AppLoaderService,
        private adalService:AdalService,
        private router:Router,
        @Inject(MD_DIALOG_DATA) public dialogData
    ){
        if (!this.adalService.getCachedToken()) {
            this.dialogRef.close(null);
            this.router.navigate(["login"]);
        }
    }
    ngOnInit(){
        this.buildForm();
        this.FaqList=this.dialogData.FaqDisplayDetail;
        this.selectedFAQDetail=this.dialogData.SelectedFAQDetail;
        if(this.selectedFAQDetail!=null){
            this.dialogTitle='Edit FAQ'
            this.FAQForm.patchValue({
                Question:this.selectedFAQDetail.Question,
                Answer:this.selectedFAQDetail.Answer
            })
        }
    }
    buildForm(){
        this.FAQForm=this.formBuilder.group({
            Question:['',[Validators.required]],
            Answer:['',[Validators.required]]
        })
    }
    onSave(){
        this.appLoader.open()
        let model;
        if(this.selectedFAQDetail!=null){ //Edit
            model={
                FAQId:this.selectedFAQDetail.FAQId,
                ProductId:19,
                OrderId:1,
                CreatedBy:Number(localStorage.getItem('userid')),
                UpdatedBy:Number(localStorage.getItem('userid')),
                Question:this.FAQForm.value.Question,
                Answer:this.FAQForm.value.Answer
            }
        }
        else{ //Add
            model={
                ProductId:19,
                OrderId:1,
                CreatedBy:Number(localStorage.getItem('userid')),
                UpdatedBy:Number(localStorage.getItem('userid')),
                Question:this.FAQForm.value.Question,
                Answer:this.FAQForm.value.Answer
            }
        }
        this.licenseService.addFAQ(model).subscribe((data)=>{
            if(!data.IsError && data.DataObject!=null){
                this.FaqList=data.DataObject;
            }
            this.appLoader.close()
            this.dialogRef.close(this.FaqList);
            
        })
    }
    onCancel(){
        this.dialogRef.close(this.FaqList);
    }
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/license-portal/faq/add-edit-faq/add-edit-faq.component.ts